import React, { useEffect } from 'react';
import {logInfo} from "../../shared/services/logger.service";
import { useNavigate } from 'react-router-dom';
import {signOutUser} from "../../shared/services/auth.service";

const LogoutPage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    logInfo('Logging out');
    signOutUser().finally(() => navigate('/'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      Successfully logged out
    </div>
  );
};

export default LogoutPage;